import React, { useContext } from "react";
import image from "../assets/images/bear.svg";
import styles from "../styles/LiveCard.module.css";
import CalculatePrize from "../helpers/CalculatePrize"
import { GiCash } from "react-icons/gi";
import TradathonContext from "../context/tradathon/TradathonContext";
const LiveCard = ({
  noOfPlayers,
  entryFees,
  prize,
  rtype,
  rname,
  joinedMembers,
  rank,
  isPaid,
  winAmt,
}) => {
  const { tradathonLoading } = useContext(TradathonContext);
  return (
    <div className={styles.Tradathon__LiveCard}>
      <div className={styles.Tradathon__LiveCard_children}>
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <p>Prize :{CalculatePrize(noOfPlayers,entryFees)}</p>
        )}
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <p style={{ color: "#E8BD6E" }}>{rtype}</p>
        )}{" "}
      </div>
      <div className={styles.Tradathon__LiveCard_children}>
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <b style={{ fontSize: "18px" }}>{rname}</b>
        )}
        <img
          src={image}
          alt="bull/bear"
          className={styles.Tradathon__LiveCard_image}
        />
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <p>Joined: {joinedMembers}</p>
        )}

        {rank && (
          <>
            
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#45AA43" }}>Rank: {rank} </p>
            )}
          </>
        )}
      </div>
      <div className={styles.Tradathon__LiveCard_children}>
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <p>Entry Fee: {entryFees}</p>
        )}
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <p style={{ color: "#45AA43" }}>
            <GiCash />
          </p>
        )}
        {tradathonLoading ? (
          <div className="skeleton text" style={{ width: "150px" }} />
        ) : (
          <p style={{ color: isPaid ? "#45AA43" : "#e8bd6e" }}>
            {isPaid ? "PAID" : "SPECTATOR"}
          </p>
        )}
      </div>
      <div className={styles.mobile__view}>
        <div>
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p>Prize :{prize}</p>
          )}
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p style={{ color: "#E8BD6E" }}>{rtype}</p>
          )}{" "}
        </div>
        <div style={{ textAlign: "right" }}>
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p>Entry Fee: {entryFees}</p>
          )}
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : winAmt&&
            <p style={{ color: "#45AA43" }}>
             {winAmt} <GiCash />
            </p>
          }

          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p style={{ color: isPaid ? "#45AA43" : "#e8bd6e" }}>
              {isPaid ? "PAID" : "SPECTATOR"}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveCard;

// <div className="Tradathon__listings__live__lists__container">
// <div className="Tradathon__listings__live__item" key={index}>
//   <div className="Tradathon__listings__live__list">
//     <p>
//       <span>Contest Name: </span>
//       {d.room.rname}
//     </p>
//     <p>
//       <span>Prize Pool: </span>
//       {d.room.entryFees}
//     </p>
//   </div>
//   <div className="Tradathon__listings__live__list">
//     {" "}
//     <p>
//       <span>Entry Fees: </span>
//       {d.room.entryFees}
//     </p>
//     <p>
//       <span>Players: </span>
//       {d.room.noOfPlayers}
//     </p>
//   </div>{" "}
//   <div className="Tradathon__listings__live__list">
//     <p className="timeLeft">
//       {moment(d.room.startTime).fromNow()}
//     </p>

//     <p>
//       <span> Ends </span>
//       {moment(d.room.endTime).fromNow()}
//     </p>
//   </div>
//   <button
//     className="TradathonRoom__join__button"
//     style={{
//       background: "rgba(69, 170, 67, 1)",
//       borderRadius: "5px",
//       whiteSpace: "nowrap",
//     }}

//     VIEW
//   </button>
// </div>
// <div className="Tradathon__people__join">
//   <p style={{ margin: "10px 0", color: "#717171" }}>{`${
//     d.room.noOfPlayers - d.room.joinedMembers
//   } left`}</p>
//   <p style={{ margin: "10px 0", color: "#717171" }}>
//     Max No: {d.room.noOfPlayers}
//   </p>
// </div>

// </div>
